var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedFront(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C80 142.4 94.4 128 112 128H208C225.6 128 240 142.4 240 160V192H272V160C272 142.4 286.4 128 304 128H400C417.6 128 432 142.4 432 160V192H480V96C480 60.8 451.2 32 416 32H96C60.8 32 32 60.8 32 96V192H80V160ZM448 224H64C28.654 224 0 252.654 0 288V456C0 469.255 10.745 480 24 480H24C37.255 480 48 469.255 48 456V416H464V456C464 469.255 474.745 480 488 480L488 480C501.255 480 512 469.255 512 456V288C512 252.654 483.346 224 448 224ZM464 368H48V288C48 279.125 55.125 272 64 272H448C456.875 272 464 279.125 464 288V368Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedFront);
export default __webpack_public_path__ + "static/media/bed-front.c5c38d9955e308fbf0ee9582f8cbdfa0.svg";
export { ForwardRef as ReactComponent };